import createRequest from "@/utils/request"
import { exportFileAcc } from "@/utils"
import responseInterceptors from "@/utils/request/interceptors/response/browser"

/**
 * 产品迭代计划列表
 */
const getIterationList = (payload: any) =>
    createRequest("SDL_URL").get("/dynamic/iteration-plan-list", {
        params: payload
    })

/**
 * 产品发布动态列表
 */
const getReleaseList = (payload: any) =>
    createRequest("SDL_URL").get("/dynamic/release-list", {
        params: payload
    })

/**
 * 产品列表
 */
const getProductsList = (payload: any) =>
    createRequest("SDL_URL").get("/products/list", {
        params: payload
    })
/**
 *  产品列表导出
 * @param payload
 */
const exportProductsList = (payload: any) => {
    const axios = createRequest("SDL_URL", true, { responseType: "blob" })
    axios.interceptors.response.use((res: any) => res, responseInterceptors[1])
    return axios.post("/products/export", payload).then(exportFileAcc)
}
/**
 * 产品详情
 */
const getProductDetail = (payload: any) =>
    createRequest("SDL_URL").get("/products/detail", {
        params: payload
    })

/**
 * 上架产品
 */
const onShelfProduct = (payload: { product_id: number; on_shelf_time: number }) =>
    createRequest("SDL_URL").post("/products/set-status-onShelf", payload)

/**
 * 下架产品
 */
const offShelfProduct = (payload: {
    product_id: number
    off_shelf_time: number
    off_shelf_reason: string
}) => createRequest("SDL_URL").post("/products/set-status-offShelf", payload)

/**
 * 恢复产品
 */
const recoverProduct = (payload: { product_id: number }) =>
    createRequest("SDL_URL").post("/products/set-status-recover", payload)

/**
 * 编辑产品
 */
const updateProduct = (payload: any) => createRequest("SDL_URL").post("/products/update", payload)

/**
 * 编辑产品线
 */
const updateSoftware = (payload: any) => createRequest("SDL_URL").post("/software/update", payload)

/**
 * 操作记录
 */
const getOperateRecord = (payload: any) =>
    createRequest("SDL_URL").get("/products/operate-record", {
        params: payload
    })

/**
 * 版本列表
 */
const getVersionList = (payload: any) =>
    createRequest("SDL_URL").get("/version/list", {
        params: payload
    })
/**
 * 版本详情
 */
const getVersionDetail = (payload: any) =>
    createRequest("SDL_URL").get("/version/detail", {
        params: payload
    })
/**
 * 版本发布 步骤一 展示列表
 */
const getLaunchList = (payload: any) =>
    createRequest("SDL_URL").get("/version/launch-list", {
        params: payload
    })
/**
 * 锁版
 */
const lockVersion = (payload: any) => createRequest("SDL_URL").post("/version/lock", payload)
/**
 * 发布版本提交
 */
const releaseVersion = (payload: any) => createRequest("SDL_URL").post("/version/release", payload)
/**
 * 版本发布 步骤一 展示列表
 */
const getVersionReleaseList = (payload: any) =>
    createRequest("SDL_URL").get("/version/release-list", {
        params: payload
    })
/**
 * 版本发布 步骤三 产品人员信息展示
 */
const getMemberInfo = (payload: any) =>
    createRequest("SDL_URL").get("/products/member-info", {
        params: payload
    })
/**
 * 版本发布消息中的详情
 */
const getReleaseDetail = (payload: any) =>
    createRequest("SDL_URL").get("/version/release-detail", {
        params: payload
    })
/**
 * 版本发布消息中的详情
 */
const getLockDetail = (payload: any) =>
    createRequest("SDL_URL").get("/version/lock-detail", {
        params: payload
    })
/**
 * 根据平台获取产品
 */
const getBySubType = (payload: any) =>
    createRequest("SDL_URL").get("/products/get-by-subtype", {
        params: payload
    })
/**
 * 获取用户可见产品线
 */
const getUserSoftware = (payload: any) =>
    createRequest("SDL_URL").get("/products/visible-software", {
        params: payload
    })
/**
 * 获取用户可见产品
 */
const getUserProduct = (payload: any) =>
    createRequest("SDL_URL").get("/products/visible-product", {
        params: payload
    })

/**
 * 获取用户可见产品名称
 */
const getUserProductName = (payload: any) =>
    createRequest("SDL_URL").get("/products/visible-product-name", {
        params: payload
    })
/**
 * 获取项目下所有产品列表
 */
const getProductAll = (payload: any) =>
    createRequest("SDL_URL").get("/products/all", {
        params: payload
    })
/**
 * 迭代计划导出
 * @param payload
 */
const exportIteration = (payload: any) => {
    const axios = createRequest("SDL_URL", true, { responseType: "blob" })
    axios.interceptors.response.use((res: any) => res, responseInterceptors[1])
    return axios.post("/export/dynamic/iteration-list", payload).then(exportFileAcc)
}
/**
 * 指定软件大类下有版本数据的产品类型
 * @param payload
 */
const getValidType = (payload: any) =>
    createRequest("SDL_URL").get("/version/valid-product-type", {
        params: payload
    })
/**
 * 调整版本排期详情页
 * @param payload
 */
const adjustScheduleDetail = (payload: any) =>
    createRequest("SDL_URL").get("/version/adjust-schedule-detail", {
        params: payload
    })
/**
 * 版本暂停/恢复修改展示列表
 * @param payload
 */
const getSuspendList = (payload: any) =>
    createRequest("SDL_URL").get("/version/suspend-list", {
        params: payload
    })
/**
 * 调整版本排期
 * @param payload
 */
const adjustSchedule = (payload: any) =>
    createRequest("SDL_URL").post("/version/adjust-schedule", payload)
/**
 * 调整版本排期
 * @param payload
 */
const getAdjustScheduleList = (payload: any) =>
    createRequest("SDL_URL").get("/version/adjust-schedule-recode", {
        params: payload
    })
/**
 * 暂停/恢复版本渠道
 * @param payload
 */
const setAdjustSchedule = (payload: any) =>
    createRequest("SDL_URL").post("/version/set-channel-suspend", payload)

/**
 * 发布暂停
 */
const releaseSuspend = (product_version_id: number) =>
    createRequest("SDL_URL").post("/version/release-suspend", {
        product_version_id
    })
/**
 * 发布暂停恢复
 */
const releaseSuspendRecover = (product_version_id: number) =>
    createRequest("SDL_URL").post("/version/release-suspend-recover", {
        product_version_id
    })
/**
 * 版本编辑校验
 */
const versionEditCheck = (payload: any) =>
    createRequest("SDL_URL").post("/version/edit-check", payload)
/**
 * [新]版本调整记录
 * @param payload
 */
const versionOperateRecords = (payload: any) =>
    createRequest("SDL_URL").get("/version/operate-records", {
        params: payload
    })
/**
 * 版本编辑
 */
const versionEdit = (payload: any) => createRequest("SDL_URL").post("/version/edit", payload)
/**
 * 编辑发布时间
 */
const editReleaseTime = (payload: any) =>
    createRequest("SDL_URL").post("/version/edit-release-time", payload)
/**
 * aigc编辑
 */
const aigcEdit = (payload: any) => createRequest("SDL_URL").post("/aigc/edit", payload)
/**
 * aigc新增
 */
const aigcAdd = (payload: any) => createRequest("SDL_URL").post("/aigc/create", payload)
/**
 * aigc列表页面
 */
const aigcList = (payload: any) =>
    createRequest("SDL_URL").get("/aigc/list", {
        params: payload
    })
/**
 * aigc列表上架
 */
const aigcUp = (payload: any) => createRequest("SDL_URL").post("/aigc/up", payload)
/**
 * aigc列表下架
 */
const aigcDown = (payload: any) => createRequest("SDL_URL").post("/aigc/down", payload)
/**
 * aigc列表导出
 * @param payload
 */
const exportAigcList = (payload: any) => {
    const axios = createRequest("SDL_URL", true, { responseType: "blob" })
    axios.interceptors.response.use((res: any) => res, responseInterceptors[1])
    return axios.post("/aigc/export", payload).then(exportFileAcc)
}
/**
 * aigc详情基本信息
 */
const aigcDetail = (payload: any) =>
    createRequest("SDL_URL").get("/aigc/detail", { params: payload })
/**
 * aigc详情页操作记录
 */
const aigcOperateRecords = (payload: any) =>
    createRequest("SDL_URL").get("/aigc/operate-records", { params: payload })

export default {
    getReleaseList,
    getIterationList,
    getProductsList,
    exportProductsList,
    getProductDetail,
    onShelfProduct,
    offShelfProduct,
    recoverProduct,
    updateProduct,
    updateSoftware,
    getOperateRecord,
    getVersionReleaseList,
    releaseVersion,
    lockVersion,
    getLaunchList,
    getVersionDetail,
    getVersionList,
    getMemberInfo,
    getReleaseDetail,
    getBySubType,
    getLockDetail,
    getUserSoftware,
    getUserProduct,
    getUserProductName,
    getProductAll,
    exportIteration,
    getValidType,
    adjustScheduleDetail,
    getSuspendList,
    adjustSchedule,
    getAdjustScheduleList,
    setAdjustSchedule,
    releaseSuspend,
    releaseSuspendRecover,
    versionEditCheck,
    versionOperateRecords,
    versionEdit,
    editReleaseTime,
    aigcAdd,
    aigcEdit,
    aigcList,
    aigcUp,
    aigcDown,
    exportAigcList,
    aigcDetail,
    aigcOperateRecords
}
